import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as uiReducer } from 'redux-ui';
import user, * as userReducer from './user';
import employees, * as fromEmployees from './employees';
import workrooms, * as fromWorkrooms from './workrooms';
import tasks, * as fromTasks from './tasks';
import estimators, * as fromEstimators from './estimators';
import iqms, * as fromIqms from './iqms';
import flags, * as fromFlags from './flags';
import stores, * as fromStores from './stores';
import markets, * as fromMarkets from './markets';
import regions, * as fromRegions from './regions';
import divisions, * as fromDivisions from './divisions';
import installers, * as fromInstallers from './installers';
import helpers, * as fromHelpers from './helpers';
import crews, * as fromCrews from './crews';
import surfaceTypes, * as fromSurfaceTypes from './surfaceTypes';
import phases, * as fromPhases from './phases';
import phase, * as fromPhase from './phase';
import pricePatches, * as fromPricePatches from './price_patches';
import payRates, * as fromPayRates from './pay_rates.js';
import payRateUploads, * as fromPayRateUploads from './pay_rate_uploads';
import schedule, * as fromSchedule from './schedule';
import savedFilters from './saved_filters';
import assignedFilters from './assigned_filters';
import pricePatchLineItems from './price_patch_line_items';
import payRateLineItems from './pay_rate_line_items';
import appointment from './appointment';
import refigureForm from './refigure_form';
import scraper from './scraper';
import cocs from './cocs';
import lrrps from './lrrps';
import walkthroughs from './walkthroughs';
import settings from './settings';
import repairInspectionReport from './repair_inspection_report';
import crewInspection from './crew_inspection';
import ptos from './ptos';
import travelingWorkDates from './traveling_work_dates';
import reports from './reports';
import error from './error';
import lineItems, * as fromLineItems from './line_items';
import uploads, * as fromUploads from './uploads';
import imsActions from './ims_actions';
import defaultInstallerPay from './default_installer_pay';
import holidayPromoSettings, * as fromHolidayPromoSettings from './holiday_promo_settings';

const AppReducer = combineReducers({
  routing: routerReducer,
  ui: uiReducer,
  user,
  employees,
  workrooms,
  tasks,
  estimators,
  iqms,
  stores,
  markets,
  regions,
  divisions,
  installers,
  helpers,
  crews,
  surfaceTypes,
  phases,
  phase,
  flags,
  pricePatchUploads: uploads('price_patch_uploads'),
  pricePatches,
  payRates,
  payRateUploads,
  schedule,
  savedFilters,
  assignedFilters,
  pricePatchLineItems,
  payRateLineItems,
  appointment,
  refigureForm,
  scraper,
  cocs,
  lrrps,
  walkthroughs,
  settings,
  repairInspectionReport,
  crewInspection,
  ptos,
  travelingWorkDates,
  reports,
  error,
  lineItems,
  bulkUpdateUploads: uploads('bulk_update_uploads'),
  marginUploads: uploads('margin_uploads'),
  activityUploads: uploads('activity_uploads'),
  lowesSurveyUploads: uploads('lowes_survey_uploads'),
  imsActions,
  defaultInstallerPay,
  holidayPromoSettings,
});

//  RootReducer, can apply logic to state before App level Reducer
export default (state, action) => {
  if (action.type.includes('LOCATION_CHANGE')) {
    const stateArr = Object.entries(state);

    stateArr.forEach((entry) => {
      const propObj = entry[1];

      if (Object.prototype.hasOwnProperty.call(propObj, 'filters') &&
          Object.prototype.hasOwnProperty.call(propObj.filters, 'data')) {
        propObj.filters.data.query = '';
        propObj.common.page = 1;
      }
    });
  }

  return AppReducer(state, action);
};

export const getRole = state => userReducer.getRole(state.user);
export const getEmployableId = state => userReducer.getEmployableId(state.user);
export const getEmployableType = state => userReducer.getEmployableType(state.user);
export const getInstallerId = state => userReducer.getInstallerId(state.user);
export const getPosition = state => userReducer.getPosition(state.user);
export const getManageVendorWorkrooms = state => userReducer.getManageVendorWorkrooms(state.user);

export const getWorkroomList = state => fromWorkrooms.getList(state.workrooms);
export const getWorkroomById = state => fromWorkrooms.getById(state.workrooms);
export const getWorkroomFilteredByIds = state => fromWorkrooms.getFilteredByIds(state.workrooms);
export const getWorkroomLoaded = state => fromWorkrooms.getLoaded(state.workrooms);
export const getWorkroomLoading = state => fromWorkrooms.getLoading(state.workrooms);
export const getWorkroomFilters = state => fromWorkrooms.getFiltersData(state.workrooms);
export const getWorkroomErrors = state => fromWorkrooms.getErrors(state.workrooms);

export const getTaskList = state => fromTasks.taskList(state.tasks);

export const getSurfaceTypeList = state => fromSurfaceTypes.surfaceTypeList(state.surfaceTypes);
export const getSurfaceTypeById = state => fromSurfaceTypes.getById(state.surfaceTypes);

// There's a pattern here that could be refactored to a factory function
export const getIqmsHasNextPage = state => fromIqms.getHasNextPage(state.iqms);
export const getIqmsLoading = state => fromIqms.getLoading(state.iqms);
export const getIqmsPage = state => fromIqms.getPage(state.iqms);
export const getIqmsById = state => fromIqms.getById(state.iqms);
export const getIqmsErrors = state => fromIqms.getErrors(state.iqms);
export const getIqmsFilters = state => fromIqms.getFiltersData(state.iqms);
export const getIqmsList = state => fromIqms.getList(state.iqms);

export const getEmployeeList = state => fromEmployees.getList(state.employees);
export const getEmployeeHasNextPage = state => fromEmployees.getHasNextPage(state.employees);
export const getEmployeePage = state => fromEmployees.getPage(state.employees);
export const getEmployeeLoading = state => fromEmployees.getLoading(state.employees);
export const getEmployeeFilters = state => fromEmployees.getFiltersData(state.employees);
export const getEmployeeErrors = state => fromEmployees.getErrors(state.employees);
export const getEmployeeById = state => fromEmployees.getById(state.employees);
export const getEmployeeInactiveVisible = state =>
  fromEmployees.getInactiveVisible(state.employees);

export const getInstallerList = state => fromInstallers.getList(state.installers);
export const getInstallerHasNextPage = state => fromInstallers.getHasNextPage(state.installers);
export const getInstallerPage = state => fromInstallers.getPage(state.installers);
export const getInstallerLoading = state => fromInstallers.getLoading(state.installers);
export const getInstallerFilters = state => fromInstallers.getFiltersData(state.installers);
export const getInstallerErrors = state => fromInstallers.getErrors(state.installers);
export const getInstallerById = state => fromInstallers.getById(state.installers);
export const getInstallerInactiveVisible = state =>
  fromInstallers.getInactiveVisible(state.installers);

export const getPhaseList = state => fromPhases.getList(state.phases);
export const getPhaseExportList = state => fromPhases.getExportList(state.exportPhases);
export const getPhaseHasNextPage = state => fromPhases.getHasNextPage(state.phases);
export const getPhasePage = state => fromPhases.getPage(state.phases);
export const getPhaseNextPage = state => fromPhases.getNextPage(state.phases);
export const getPhasesLoading = state => fromPhases.getLoading(state.phases);
export const getPhaseFilters = state => fromPhases.getCurrentQuery(state.phases);
export const getPhaseFiltersQueryOnly = state => fromPhases.getCurrentQueryNoLocation(state.phases);
export const getPhasesErrors = state => fromPhases.getErrors(state.phases);
export const getPhaseFiltersData = state => fromPhases.getFiltersData(state.phases);
export const getPhaseFiltersLocation = state => fromPhases.getFiltersLocation(state.phases);

export const getPhaseLoading = state => fromPhase.getLoading(state.phase.details);
export const getPhaseErrors = state => fromPhase.getErrors(state.phase.details);
export const getPhaseEvents = (state, kind) => fromPhase.getEvents(state.phase.details, kind);
export const getPhaseFlags = state => fromPhase.getFlags(state.phase.details);

export const getHelperById = state => fromHelpers.getById(state.helpers);
export const getCrewById = state => fromCrews.getById(state.crews);

export const getStoreList = state => fromStores.getList(state.stores);
export const getStoreHasNextPage = state => fromStores.getHasNextPage(state.stores);
export const getStorePage = state => fromStores.getPage(state.stores);
export const getStoreLoading = state => fromStores.getLoading(state.stores);
export const getStoreLoaded = state => fromStores.getLoaded(state.stores);
export const getStoreErrors = state => fromStores.getErrors(state.stores);
export const getStoreById = state => fromStores.getById(state.stores);
export const getStoreFilters = state => fromStores.getFiltersData(state.stores);
export const getStoreInstallerPrioritization = state =>
  fromStores.getInstallerPrioritization(state.stores);
export const getStoreMeasurePrioritization = state =>
  fromStores.getMeasurePrioritization(state.stores);

export const getMarketList = state => fromMarkets.marketsList(state.markets);
export const getDivisionList = state => fromDivisions.divisionsList(state.divisions);
export const getRegionList = state => fromRegions.regionsList(state.regions);

export const getEstimatorList = state => fromEstimators.getList(state.estimators);
export const getEstimatorHasNextPage = state => fromEstimators.getHasNextPage(state.estimators);
export const getEstimatorLoading = state => fromEstimators.getLoading(state.estimators);
export const getEstimatorPage = state => fromEstimators.getPage(state.estimators);
export const getEstimatorById = state => fromEstimators.getById(state.estimators);
export const getEstimatorErrors = state => fromEstimators.getErrors(state.estimators);
export const getEstimatorFilters = state => fromEstimators.getFiltersData(state.estimators);

export const getPricePatchesList = state => fromPricePatches.getList(state.pricePatches);
export const getPricePatchById = state => fromPricePatches.getById(state.pricePatches);

export const getFlagOptions = state => fromFlags.getFlags(state.flags);

export const getHolidayPromoSetting = state =>
  fromHolidayPromoSettings.getHolidayPromoSetting(state.holidayPromoSettings);
export const getHolidayPromoSettingLoading = state =>
  fromHolidayPromoSettings.getHolidayPromoSettingLoading(state.holidayPromoSettings);
export const getHolidayPromoSettingErrors = state =>
  fromHolidayPromoSettings.getHolidayPromoSettingErrors(state.holidayPromoSettings);

export const getVendorTypes = fromLineItems.getVendorTypes;

export const folderDocuments = (docs) => {
  const folders = {};
  docs.map((doc) => {
    const docType = doc.document_type;
    if (!folders[docType]) {
      folders[docType] = [];
    }
    folders[docType].push(doc);
    return null;
  });

  Object.keys(folders).map((folder) => {
    const docums = folders[folder];
    docums.sort((docA, docB) => {
      if (docA.not_use !== docB.not_use) {
        if (docA.not_use && !docB.not_use) {
          return 1;
        }

        if (docB.not_use && !docA.not_use) {
          return -1;
        }
        return 0;
      }

      return docA.id < docB.id ? 1 : -1;
    });

    return null;
  });

  return folders;
};

export const getPhaseDocuments = state => folderDocuments(state.phase.documents.data);

export const getDocumentUploadError = state => state.phase.documents.uploadError;
export const getDocumentUploadLoading = state => state.phase.documents.filesLoading;

export const getPayRateCurrentHistoryList = state =>
  fromPayRates.getCurrentHistoryList(state.payRates);
export const getPayRateLoading = state => fromPayRates.getLoading(state.payRates);
export const getPayRateShowHistory = state => fromPayRates.getShowHistory(state.payRates);
export const getPayRateCurrentName = state => fromPayRates.getCurrentName(state.payRates);

export const getPayRateUploadsListData = state =>
  fromPayRateUploads.getListData(state.payRateUploads);
export const getPayRateUploadsError = state =>
  fromPayRateUploads.getUploadError(state.payRateUploads);
export const getPayRateUploadsLoading = state =>
  fromPayRateUploads.getFileLoading(state.payRateUploads);
export const getPayRateUploadsMessage = state =>
  fromPayRateUploads.getUploadMesage(state.payRateUploads);
export const getPayRateUploadsShowDialog = state =>
  fromPayRateUploads.getShowDialog(state.payRateUploads);

export const getScheduleLoading = state => fromSchedule.getLoading(state.schedule);
export const getScheduleErrors = state => fromSchedule.getErrors(state.schedule);
export const getScheduleDates = state => fromSchedule.getDates(state.schedule);

export const getUploadListData = state => fromUploads.getListData(state);
export const getUploadPage = state => fromUploads.getPage(state);
export const getUploadHasNextPage = state => fromUploads.getHasNextPage(state);
export const getUploadListLoading = state => fromUploads.getListLoading(state);
export const getUploadError = state => fromUploads.getUploadError(state);
export const getUploadLoading = state => fromUploads.getFileLoading(state);
export const getUploadDialogStatus = state => fromUploads.getDialogActive(state);
export const getUploadIsProcessing = state => fromUploads.getUploadIsProcessing(state);
export const getUploadTotalCount = state => fromUploads.getTotalCount(state);



// WEBPACK FOOTER //
// ./client/app/reducers/index.js